import { BaseReducer } from '@hobs/utils/baseReducer';
import { GET } from '@hobs/constants/subcontractors';

class Subcontractors extends BaseReducer {
  static defaultState = {
    list: []
  };

  constructor() {
    super(Subcontractors.defaultState);

    this.actionMap = {
      [GET.SUCCESS]: this.getSubcontractorsSuccess
    };
  }

  getSubcontractorsSuccess = (state, action) => {
    return Object.assign({}, state, { list: action.list });
  };
}

export default new Subcontractors().reducer;
